import {DateStringNullable, NullableKeys, Dictionary, todayDate} from '@fl/cmsch-fe-library';
import {opt} from 'ts-opt';

import {allOptionValueArray} from 'app/admin/constants/consts';

/** Form name used by the organization management modal. */
export const managementOrganizationFormName = 'managementOrganizationForm';

/** Admin organization-management form type. */
export type ManagementOrganizationFormTag =
    'ValidateCreateOrganizationBindingManager' | 'ValidateUpdateOrganizationBindingManager';

/** Admin organization-management form type. */
export interface ManagementOrganizationFormValues {
    /** Approval start date. */
    approvedFrom: DateStringNullable;
    /** Approval end date. */
    approvedTo: DateStringNullable;
    /** Selected farm ids. */
    farmIds: Array<number> | null;
    /** Selected organization center ids. */
    organizationCenterIds: Array<number> | null;
    /** Selected organization id. */
    organizationId: number;
    /** Selected role ids. */
    roleIds: Array<number>;
    /** Selected user profile id, if any. */
    userProfileId: number | null;
    /** Existing organization-role binding id, if any. */
    userProfileOrganizationRoleId: number | null;
    /** Backend validation tag. */
    tag: ManagementOrganizationFormTag;
}

/**
 * Default values for the organization management modal.
 *
 * @param userProfileId Selected user profile id, if any.
 * @param roleId Selected role id, if any.
 * @param organizationId Selected organization id, if any.
 * @returns Default organization-management form values.
 */
export const managementOrganizationFormInitialValues = (
    userProfileId: number | null,
    roleId: number | null,
    organizationId: number | null,
): NullableKeys<ManagementOrganizationFormValues> => ({
    approvedFrom: todayDate(),
    approvedTo: null,
    farmIds: allOptionValueArray,
    organizationCenterIds: allOptionValueArray,
    organizationId,
    roleIds: opt(roleId).toArray(),
    userProfileId,
    userProfileOrganizationRoleId: null,
    tag: 'ValidateCreateOrganizationBindingManager',
});

/** Admin organization-management form type. */
export type ManagementOrganizationFormValuesErrors = Dictionary<
    keyof ManagementOrganizationFormValues, string
>;
